// React Imports
import type { ReactNode } from 'react';

// Third-party Imports
import classnames from 'classnames';

// Type Imports
import type { ChildrenType } from '../@core/types';

// Component Imports
import LayoutContent from './components/vertical/LayoutContent';

// Util Imports
import { verticalLayoutClasses } from './utils/layoutClasses';

import { useGlobalStore } from '@ice-web-app/shared-store';
import { useSettings } from '../@core/hooks/useSettings';
// Styled Component Imports
import StyledContentWrapper from './styles/vertical/StyledContentWrapper';

type VerticalLayoutProps = ChildrenType & {
  navigation?: ReactNode;
  navbar?: ReactNode;
  footer?: ReactNode;
};

export const VerticalLayout = (props: VerticalLayoutProps) => {
  // Props
  const { navbar, navigation, children } = props;
  const { fullScreenContent } = useGlobalStore();

  return (
    <div className={classnames(verticalLayoutClasses.root, 'flex flex-auto')}>
      {(!fullScreenContent && navigation) || null}
      <StyledContentWrapper
        className={classnames(verticalLayoutClasses.contentWrapper, 'flex flex-col min-is-0 is-full')}
        style={{ minHeight: '100vh' }}
      >
        {(!fullScreenContent && navbar) || null}
        {/* Content */}
        <LayoutContent>{children}</LayoutContent>
        {/* {footer || null} */}
      </StyledContentWrapper>
    </div>
  );
};
